export function isGrantArchived(grant) {
  return String(grant?.fields?.Archived) === 'true';
}

export function filterActiveGrants(grants) {
  return (grants || []).filter((grant) => !isGrantArchived(grant));
}
